export var REG_EXP = {
  validTestEmail: /@test.com/,
  https: /(https?:\/\/[^\s]+)/g,
  lineBreak: /\r\n/g
};